<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    {{ "MasterData.NewCatalogItemModal.Title" | i18nextEager }}
  </ng-template>
  <ng-template #content>
    <form [formGroup]="form">
      <div class="flex flex-col gap-lg">
        <doka-text-field
          [frontDecoText]="i18n.selectedLanguage.toUpperCase()"
          formControlName="name"
          data-testid="create-catalog-item-name-input"
          [label]="'MasterData.NewCatalogItemModal.Name' | i18nextEager"
          [placeholder]="'Common.Placeholder' | i18nextEager"
        />

        <doka-select
          class="w-full"
          formControlName="categoryId"
          data-testid="create-catalog-item-category-select"
          [label]="'MasterData.NewCatalogItemModal.Category' | i18nextEager"
          [placeholder]="'MasterData.NewCatalogItemModal.CategoryPlaceholder' | i18nextEager"
        >
          @for (category of catalogCategories.value()?.data; track category.id) {
            <doka-select-option
              [value]="category.id"
              [label]="category.code + ' - ' + category.name"
            ></doka-select-option>
          }
        </doka-select>

        <doka-select
          class="w-full"
          formControlName="inventoryNumberId"
          data-testid="create-catalog-item-inventory-number-select"
          [label]="'MasterData.NewCatalogItemModal.InvNumber' | i18nextEager"
          [placeholder]="'Common.Placeholder' | i18nextEager"
        >
          @for (invNumber of inventoryNumbers.value()?.data; track invNumber) {
            <doka-select-option
              [value]="invNumber.id"
              [label]="invNumber.number + ' - ' + invNumber.name"
            ></doka-select-option>
          }
        </doka-select>
      </div>
    </form>
  </ng-template>
  <ng-template #footer>
    <div class="flex flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button
          [disabled]="isLoading()"
          (click)="closeModal()"
          color="secondary"
          data-testid="create-catalog-item-cancel-button"
          >{{ "Common.Cancel" | i18nextEager }}</doka-button
        >
        <doka-button
          type="submit"
          [disabled]="form.invalid || isLoading()"
          (click)="submit()"
          color="primary"
          data-testid="create-catalog-item-save-button"
          >{{ "Common.Save" | i18nextEager }}</doka-button
        >
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
